document.addEventListener('DOMContentLoaded', function () {
  var customBanner = document.getElementById('custom_banner');
  var customBannerContent = document.getElementById('custom_banner_content');
  var closeBanner = document.getElementById('close_btn_banner');

  // Function to show the popup
  function showBanner() {
    if (!sessionStorage.getItem('isCloseCustomBanner')) {
      customBanner.style.display = 'block';
    }
  }

    // Show popup after 2 seconds
  setTimeout(showBanner, 2000);

  closeBanner.addEventListener('click', function () {
    customBanner.style.display = 'none';
      sessionStorage.setItem('isCloseCustomBanner', 'true');
  });

    customBannerContent.addEventListener('click', function () {
    window.open('https://munica.rite.co.jp/advertisement/share/LS7K0xJdUgNuRjsLTF8SLbLJz7HddQ0024', '_blank').focus();
  });
});
